import React from 'react';

import { useTranslation } from '@bcp-channels-sharedcomponents-reactjs/core/dist/hooks';
import { Box, Typography } from '@bcp-nextgen-dx-component-factory/design-system';
import { BankDocument, ComponentInfo } from '@components';
import { rem } from '@helpers';

import { AccountSelected, ChangeEmail, CostSummary } from './block';

export const ResumeAndAuthorizationPlaceholder: React.FC = () => {
	const t = useTranslation();
	return (
		<ComponentInfo name="ResumeAndAuthorizationPlaceholder" type="placeholder">
			<Typography appearance="headline-200-02" styles={{ marginBottom: rem(40) }}>
				{t('placeholders.resumeAndAuthorization.title')}
			</Typography>
			<Box styles={{ flexDirection: 'column', gap: rem(16) }}>
				<CostSummary />
				<AccountSelected />
				<BankDocument />
				<ChangeEmail />
			</Box>
		</ComponentInfo>
	);
};
